import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieboxService } from './cookiebox.service';
import { GeneralPrivacyStatementComponent } from './components/general-privacy-statement/general-privacy-statement.component';
import { CookieboxPrivacyStatementResolver } from './resolvers/cookiebox-privacy-statement.resolver';
import { CookieboxMultiplePrivacyStatementResolver } from './resolvers/cookiebox-multiple-privacy-statement.resolver';
import { CookieboxContentContainerComponent } from './components/cookiebox-content-container/cookiebox-content-container.component';

@NgModule({
    imports: [CommonModule, GeneralPrivacyStatementComponent, CookieboxContentContainerComponent],
    providers: [CookieboxService, CookieboxPrivacyStatementResolver, CookieboxMultiplePrivacyStatementResolver],
    exports: [GeneralPrivacyStatementComponent, CookieboxContentContainerComponent],
})
export class CookieboxModule {}
